import { computed, ref } from '@vue/composition-api'
import { ALL_SPORTS_MAP, parseSportByName, isValidSportId } from './map.js'

export default function useCurrentSport(defaultSportId = '') {
  const defaultId = isValidSportId(defaultSportId) ? defaultSportId : ''
  const currentSportId = ref(defaultId)
  const currentSportName = computed(() => ALL_SPORTS_MAP[currentSportId.value])
  const currentSport = computed(() => ({ sportId: currentSportId.value, sportName: currentSportName.value }))

  const updateCurrentSportId = (sportId = '', sportName = '') => {
    if (sportId && sportId.indexOf('%') !== -1) {
      sportId = decodeURIComponent(sportId)
    }
    if (sportId && !isValidSportId(sportId)) return

    if (sportName) {
      const sportInfo = parseSportByName(sportName)
      if (sportInfo) {
        sportId = sportInfo.sportId
      }
    }

    currentSportId.value = sportId
  }

  return {
    currentSportId,
    currentSportName,
    currentSport,
    updateCurrentSportId
  }
}
